export enum WebDefine {
  // 测试服
  //PHP_TEST_URL = "http://159.75.235.100:8677/",
  // oxlint-disable-next-line typescript/no-duplicate-enum-values
  PHP_TEST_URL = 'https://2testdev20260323.big-win.one/', // 竖版
  WEB_TEST_URL = 'https://2testdev20260323.big-win.one/', // 竖版
  // oxlint-disable-next-line typescript/no-duplicate-enum-values
  PAY_TEST_URL = 'https://pay.big-win.one/',

  // 正式服
  PHP_URL = 'https://api.toppkwin.com/',
  WEB_URL = 'https://report.toppkwin.com/',
  PAY_URL = 'https://pay.big-win.one/',

  // :============== 竖版 begin ============

  // test
  testErrorUrl = 'https://api.example.com/data',
  users = 'users',

  // :============== 竖版 end ============

  config = 'api/channel/config',

  // :============== pay begin ============
  createPayOrder = 'rummy/myPay/createPayOrderV2',
  // :============== pay end ============

  // :============== web begin ============
  appSendData = 'appSendData',
  addUserInfo = 'addUserInfo',
  sendSEProperties = 'addRechargeInfo',
  // :============== web end ============

  // :============== h5 games begin ============
  getH5GameUrl = 'api/game/url',
  getH5FreeGame = 'api/game/freeGame',
  // h5 游戏下分
  downScore = 'api/rollover/downScore',
  // :============== h5 games end ============

  otp = 'api/user/otp',
  bindPhone = 'api/user/bindPhone',

  //获取APP版本
  getVersion = 'version/VersionByCid',

  //  专属收款账号（UPI）收款
  getShopBuyUrlForUPI = 'adminBackend/v4/payOrder/mpurse',

  //  获取渠道支付、提现 支付方式配置信息地址
  getBankConfigUrl = 'adminBackend/v4/channel/getConfig',

  //  获取头像上传地址
  getHeadUploadUrl = 'adminBackend/v4/upload/uploadAvatar',

  //  获取证件照上传地址
  getCredentialsUploadUrl = 'adminBackend/v4/upload/uploadKyc',

  //  获取kyc证件审核信息地址
  getKYCCardInfoUrl = 'adminBackend/v4/kyc/userKycInfo',

  //  获取kyc信息上传地址
  getKYCDetailUrl = 'adminBackend/v4/kyc/userKycUpdate',

  //  获取证件照上传地址
  getUploadKYCImageUrl = 'adminBackend/v4/kyc/uploadKycV1',

  //  获取kyc证件审核信息地址
  getKYCInfoUrl = 'adminBackend/v4/kyc/userKycInfoV1',

  //  获取kyc信息上传地址
  getUpdateKYCUrl = 'adminBackend/v4/kyc/userKycUpdateV1',

  kycPCardSaveStep1 = 'adminBackend/v4/kyc/kycPCardSaveStep1',

  kycPCardSaveStep2 = 'adminBackend/v4/kyc/kycPCardSaveStep2',

  kycACardSaveStep1 = 'adminBackend/v4/kyc/kycACardSaveStep1',

  kycACardSaveStep2 = 'adminBackend/v4/kyc/kycACardSaveStep2',

  checkACardOtp = 'adminBackend/v4/kyc/checkACardOtp',

  kycACardSaveStep3 = 'adminBackend/v4/kyc/kycACardSaveStep3',

  kycV3ACardSaveStep1 = 'adminBackend/v4/kyc/kycV3ACardSaveStep1',

  kycV3ACardSaveStep2 = 'adminBackend/v4/kyc/kycV3ACardSaveStep2',

  blockConfig = 'adminBackend/v4/hu',

  checkPhoneOtp = 'adminBackend/v4/kyc/iosKycOtp',

  kycPhoneSave = 'adminBackend/v4/kyc/iosKycPhone',

  skipKYCConfig = 'adminBackend/v4/user/skipKycPay',

  userVipInfo = 'api/vip/cardList',

  userGetGold = 'adminBackend/v4/vip/userGetGold',

  //  任务
  userActiveList = 'adminBackend/v4/active/userActiveList',

  userRecvGold = 'adminBackend/v4/active/userRecvGold',

  skipCheckLocation = 'api/user/skipCheckLocation',

  configs = 'api/user/configs',

  //getsubgamelist = "api/game/list",
  getGameSupplierList = 'api/game/GameSupplierList', //获取游戏厂商

  getGameTypeList = 'api/game/GameTypeList', //获取游戏种类

  getlistbyCid = 'api/game/GameListByCid', //获取游戏总列表

  GameTypeGames = 'api/game/GameTypeGames', //获取初始列表种类

  GameSupplierGames = 'api/game/GameSupplierGames', //获取初始列表厂商

  goodslist = 'api/goods/list',

  getPayConfig = 'api/pay/list',

  getPayWheel = 'api/active/payWheelList',

  getPayMent = 'api/pay/walletList',

  payWheelSpin = 'api/active/payWheelSpin',

  wheelRewardList = 'api/active/payWheelRecord',

  userVipDailyCashInfo = 'api/giftPack/list',

  userGetDailyCash = 'api/giftPack/rcvReward',

  // 分享界面
  shareGetReward = 'api/invite/reward',

  shareGetRule = 'api/invite/config',

  shareGetReferrals = 'api/invite/record',

  shareBind = 'api/invite/bind',

  shareGetRecvReward = 'api/invite/rcvReward',

  ActiveInviteRecord = 'api/active/ActiveInviteRecord',

  ActivelnviteGet = 'api/active/ActiveInviteGet',

  ActiveVipUpgradeRecord = 'api/active/ActiveVipUpgradeRecord',

  ActiveVipUpgradeGet = 'api/active/ActiveVipUpgradeGet',

  // 跑马灯
  houseRace = 'adminBackend/v4/game/marquee',

  //  获取客服邮箱和 tg
  tg = 'api/channel/tg',

  //  获取每日任务 （积分进度）
  userDailyTasksInfo = 'adminBackend/v4/active/getPointsProgress',

  //  获取每日任务 （任务列表）
  userDailyTasksList = 'adminBackend/v4/active/getActiveList',

  //  获取每日任务 （转盘列表）
  userDailyTasksWheel = 'adminBackend/v4/active/getWheel',

  //  获取每日任务 （Gullak奖励）
  userDailyTasksGullak = 'adminBackend/v4/active/getGullak',

  //  获取每日任务 （领取奖励）
  userDailyTasksReward = 'adminBackend/v4/active/recvReward',

  //  获取每日任务 （提取金币）
  userDailyTasksGold = 'adminBackend/v4/active/withdrawGold',

  //  获取每日任务 （转动转盘）
  userDailyTasksWheelSpin = 'adminBackend/v4/active/wheelSpin',

  //  获取每日任务 （跑马灯列表）
  userDailyTasksMarquee = 'adminBackend/v4/active/getMarquee',

  //  获取每日任务 （分享游戏）
  userDailyTasksShare = 'adminBackend/v4/active/share',

  // vip权益配置
  userVipEquityConfig = 'api/vip/config',

  // vip权益列表
  userVipEquityRewardList = 'api/vip/reward',

  // vip领取奖励
  userVipEquityRecvReward = 'api/vip/rcvReward',

  //打码订单列表
  userRolloverList = 'api/rollover/list',

  //fb事件上报
  faceBookSend = 'api/event/send',

  //新手活动
  userWelcomeList = 'api/startPack/list',

  //opt发送短信验证码
  userOPTSend = 'code/optSend',

  //opt发送短信验证码（颂量）
  userOPTSendSG = 'api/user/otpSend',

  //opt短线登录验证码
  userOPTVerifySend = 'code/optVerify',

  //更改密码用户名手机号码等
  updateUserInfoNoSign = 'userNoSign/updateUserInfoNoSign',

  //核对玩家手机号码账号
  checkUserInfoNoSign = 'userNoSign/checkUserInfoNoSign',

  //用账户密码绑定玩家
  BindUserInfoNoCode = 'api/user/bindUserPhoneNoCode',

  //用户绑定银行卡
  BindUserBankNo = 'api/user/bindUserBankNo',

  //用户清空银行卡
  ClearUserBankNo = 'api/user/clearUserBankNo',

  //获取用户信息
  GetUserInfoNo = 'api/user/getUserInfo',

  //提现
  userWithdraw = 'api/user/UserWithdraw',

  //累计充值活动
  ActiveGearConfig = 'api/active/ActiveGearConfig',

  //累计充值奖励领取
  ActiveRecordAdd = 'api/active/ActiveRecordAdd',

  //fb上传绑定参数
  fbReportCharge = 'https://api.big-win.one/fbEvent/ReportCharge',
  //MARK: lucky2d
  //
  thaiStock2DDailyLive = 'thaiStock2D/DailyLive',
  Play2DCountPlay2DCount = 'api/thaiStock2D/Play2DCount',
  Play2DPlay2DInfo = 'api/thaiStock2D/Play2DInfo',
  Play2DLiveRankingList = 'api/thaiStock2D/LiveRankingList',
  Play2DLiveHistoryList = 'api/thaiStock2D/LiveHistoryList',
  Play2DLiveWinStatus = 'api/thaiStock2D/LiveWinStatus',
  Live2DNewMessage = 'api/thaiStock2D/Live2DNewMessage',

  thaiStock3DDailyLive = 'thaiStock2D/DailyLive3d',
  Play3DCountPlay3DCount = 'api/thaiStock2D/Play3DCount',
  Play3DPlay3DInfo = 'api/thaiStock2D/Play3DInfo',
  Play3DLiveRankingList = 'api/thaiStock2D/Live3DRankingList',
  Play3DLiveWinStatus = 'api/thaiStock2D/Live3DWinBalance',
  Live3DNewMessage = 'api/thaiStock2D/Live3DNewMessage',
}
